// extracted by mini-css-extract-plugin
export var modal_button = "restore-password-complete-module--modal_button--2B5-W";
export var recover_description = "restore-password-complete-module--recover_description--wdU+g";
export var recover_head = "restore-password-complete-module--recover_head--XHB9a";